import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaEye, FaEyeSlash, FaGoogle, FaApple } from 'react-icons/fa';
import { useGoogleLogin } from '@react-oauth/google'; 
import './Login.css'; 

const PRIMARY_COLOR = "#FF7B00"; 
const LOGO_TEXT_COLOR = "#333";

const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);
const validatePassword = (password) => {
    if (password.length < 8) return 'Must be at least 8 characters';
    if (!/(?=.*[a-z])/.test(password)) return 'Must contain a lowercase letter';
    if (!/(?=.*[A-Z])/.test(password)) return 'Must contain an uppercase letter';
    if (!/(?=.*\d)/.test(password)) return 'Must contain a number';
    if (!/(?=.*[@$!%*?&])/.test(password)) return 'Must contain a symbol (@$!%*?&)';
    return '';
};

const Signup = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});

    const googleLogin = useGoogleLogin({
        onSuccess: (tokenResponse) => {
            console.log("Google Login Success! Token:", tokenResponse);
            alert("Google Sign-In successful! (Backend validation required)");
        },
        onError: (error) => {
            console.log("Google Login Failed:", error);
            alert("Google Sign-In failed.");
        },
    });

    const handleAppleLogin = () => {
        alert("Apple Sign-In requires dedicated Apple Developer setup and server-side flow.");
    };


    const validate = () => {
        const newErrors = {};
        if (!name) newErrors.name = 'Full Name is required';
        else if (name.length < 3) newErrors.name = 'Name must be at least 3 characters';
        if (!email) newErrors.email = 'Email is required';
        else if (!validateEmail(email)) newErrors.email = 'Invalid email format';
        const passwordError = validatePassword(password);
        if (passwordError) newErrors.password = passwordError;
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            console.log('Signup successful:', { name, email, password });
            alert('Signup successful! (Check console)');
        }
    };

    return (
        <div className="auth-container">
            <div className="form-side">
                <h2 className="form-title" style={{ color: LOGO_TEXT_COLOR }}>Join Aruba Networks</h2>
                <form onSubmit={handleSubmit} className="auth-form">
                    
                    <div className="input-group">
                        <label htmlFor="name">Full Name</label>
                        <input id="name" type="text" placeholder="Sushmashree" value={name} onChange={(e) => setName(e.target.value)} className={errors.name ? 'input-error' : ''} />
                        {errors.name && <p className="error-message">{errors.name}</p>}
                    </div>
                    
                    <div className="input-group">
                        <label htmlFor="email">Email</label>
                        <input id="email" type="email" placeholder="sushma@aruba.com" value={email} onChange={(e) => setEmail(e.target.value)} className={errors.email ? 'input-error' : ''} />
                        {errors.email && <p className="error-message">{errors.email}</p>}
                    </div>
                    
                    <div className="input-group">
                        <label htmlFor="password">Password</label>
                        <div className="password-wrapper">
                            <input id="password" type={showPassword ? 'text' : 'password'} placeholder="Min 8 chars, mixed case, number, symbol" value={password} onChange={(e) => setPassword(e.target.value)} className={errors.password ? 'input-error' : ''} />
                            <span className="password-toggle" onClick={() => setShowPassword(!showPassword)}>{showPassword ? <FaEyeSlash /> : <FaEye />}</span>
                        </div>
                        {errors.password && <p className="error-message">{errors.password}</p>}
                    </div>

                    <button type="submit" className="primary-btn">Sign Up</button>
                    <div className="divider">OR</div>
                    
                    
                    <div className="social-icon-group">
                        <button type="button" className="social-icon google-icon" onClick={() => googleLogin()}>
                            <FaGoogle />
                        </button>
                        <button type="button" className="social-icon apple-icon" onClick={handleAppleLogin}>
                            <FaApple />
                        </button>
                    </div>
                    
                    <p className="switch-link">
                        Already have an account? 
                        <Link to="/login" style={{ color: PRIMARY_COLOR, fontWeight: 'bold' }}>Log In</Link>
                    </p>
                </form>
            </div>
            
            <div className="brand-side" style={{ backgroundColor: PRIMARY_COLOR }}>
                <div className="logo-box">
                    <span className="logo-main">aruba</span>
                    <p className="logo-sub">NETWORKS</p>
                    <p className="brand-quote">Build your secure and intelligent edge with us.</p>
                </div>
            </div>
        </div>
    );
};

export default Signup;
